import { render } from "./ConConfigFormasPagamentoView.vue?vue&type=template&id=982a04c0&scoped=true"
import script from "./ConConfigFormasPagamentoView.vue?vue&type=script&lang=js"
export * from "./ConConfigFormasPagamentoView.vue?vue&type=script&lang=js"

import "./ConConfigFormasPagamentoView.vue?vue&type=style&index=0&id=982a04c0&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-982a04c0"]])

export default __exports__